// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"252":"4c8d1e8c","619":"2f11e868","871":"bb41ab26","952":"67be8a58"}[chunkId] + ".chunk.css";
};